import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {LabelContainerModel} from '../../../../../../models/aggregates/erp/label';
import {Core2Config} from '../../shared/core2Config';
import {ApiResponseModel, BasicApiResponseModel} from '../../shared/api-response.model';
import {ApiVisa} from '../../shared/api-visa.model';
import {LabelCriteriaModelQuery, LabelQueryCriteriaClass} from '../../../criteria';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShopeeCreateProductService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/create-products';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/create-products';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/create-products';
    this.httpClient = http;
  }

  public createProduct(
    dtoObject: any,
    branchGuid,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '?branch_guid=' + branchGuid;
    return this.httpClient.post<BasicApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
